import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaMemberList } from '@/service/tuina'

const processSingleDataType = ({ data, dataType }) => {
  if (!dataType || dataType === 'default') return data || {}
  const list = data && Array.isArray(data.list) ? data.list : []
  switch (dataType) {
    case 'option':
      return list.map((item) => ({
        id: `${item.id}`,
        value: item.phone ? `${item.name} ${item.phone}` : item.name,
        phone: item.phone
      }))
    default:
      return data || {}
  }
}

export const fetchTuinaMemberList = createAsyncThunk(
  'tuinaMemberList/fetchTuinaMemberList',
  async ({ query = {}, dataType } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaMemberList(query)
      return {
        data: response.data,
        query,
        dataType
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载会员失败'
      )
    }
  }
)

const memberListSlice = createSlice({
  name: 'tuinaMemberList',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaMemberList.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaMemberList.fulfilled, (state, action) => {
        const { data, dataType, query } = action.payload || {}
        state.fetching = false
        state.error = null
        state.query = query
        state.data = processSingleDataType({ data, dataType })
      })
      .addCase(fetchTuinaMemberList.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default memberListSlice.reducer
